// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2kUrB","inputWrap":"CustomTip_inputWrap__3Z1kn"};